import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Service, inject } from '@angular/core';
import { ContentLoaderComponent } from '@shared/components/content-loader';

@Service()
export class LoaderService {
    private overlay = inject(Overlay);

    private contentLoader = new ComponentPortal(ContentLoaderComponent);
    private overlayRef: OverlayRef = this.overlay.create({
        width: '100vw',
        height: '100vh',
        hasBackdrop: true,
    });

    public open(): void {
        this.overlayRef.detach();
        this.overlayRef.attach(this.contentLoader);
    }

    public close(): void {
        this.overlayRef.detach();
    }

    public openInitialLoader(): void {
        document.querySelector('.initial-app-loader-wrapper')?.classList.add('bg--white-coffee');
        document.querySelector('.initial-app-loader-wrapper')?.classList.remove('initial-app-loader-wrapper--hide');
    }

    public closeInitialLoader(): void {
        document.querySelector('.initial-app-loader-wrapper')?.classList.add('initial-app-loader-wrapper--hide');
        document.querySelector('.initial-app-loader-wrapper')?.classList.remove('bg--white-coffee');
    }
}
